import { z } from "zod"

export const jsonSchema = z.string().transform((str, ctx) => {
  try {
    return JSON.parse(str)
  } catch {
    ctx.addIssue({
      code: "custom",
      message: "Invalid JSON format",
    })
    return z.NEVER
  }
})

export type JsonSchema = z.infer<typeof jsonSchema>
